<template>
	<div class="my-5">
		<v-col>
			<v-row v-for="product in products" :key="product.name" no-gutters>
				<ProductItem
					:productInfo="product"
					:cartInfo="store.newOrderItems"
					@quantityChanged="updateTotalBtn"
				/>
			</v-row>

			<v-row justify="center" align="center" class="mb-3 mt-0 pt-0">
				<v-col cols="12" sm="10" md="8" lg="6" xl="4" class="px-0 mt-0 pt-0">
					<v-card
						class="d-flex flex-wrap justify-center align-center card px-0 py-5"
						elevation="5"
					>
						<v-col justify="center" align="center" class="pa-0" cols="4">
							<h5 class="px-1" translate>{{ $t(["Miscellaneous Item"]) }}</h5>
						</v-col>

						<div
							class="d-flex flex-column flex-wrap"
							justify="center"
							align="center"
						>
							<!-- <div
                placeholder="{{ 'Add Miscellaneous Item to order' | translate }}"
              ></div> -->
							<v-switch
								v-model="miscItem"
								:label="$t(['Add Miscellaneous Item to order'])"
								class="mt-0 px-3 py-3"
								color="primary"
								hide-details
							></v-switch>

							<v-row
								v-show="miscItem"
								justify="center"
								align="center"
								class="mx-5"
							>
								<div style="width: 125px">
									<!-- <div placeholder="{{ 'Amount' | translate }}"></div> -->
									<v-text-field
										:label="$t(['Amount'])"
										v-model="miscItemPrice"
										class="centered-input error-field pt-3"
										:prefix="$i18n.locale == 'en' ? '$' : ''"
										:suffix="$i18n.locale == 'fr' ? '$' : ''"
										maxlength="7"
										dense
										:error="textfieldError"
										:error-messages="textfieldErrorMsg"
										ref="miscInput"
										@click="selectAllText()"
										@blur="maskCurrency"
									>
									</v-text-field>
								</div>
							</v-row>
						</div>
					</v-card>
				</v-col>
			</v-row>
		</v-col>

		<v-footer color="white" app bottom fixed padless>
			<v-row justify="center" align="center">
				<v-col cols="10" md="8" lg="5" xl="4">
					<v-btn
						class="btn-text"
						color="primary"
						x-large
						block
						@click="goToSummary()"
					>
						<h4>
							{{ $t(["TOTAL"]) }}
							<span
								v-html="$t('Currency', { amount: priceTotal.toFixed(2) })"
							></span>
							- ({{ quantityTotal }})
						</h4>
					</v-btn>

					<p
						v-show="noItemErrorMsg"
						class="error--text error-font-size mt-1"
						align="center"
						translate
					>
						{{ $t(["No items selected"]) }}
					</p>

					<v-btn class="btn-text mt-10" x-large block @click="backToHome()">
						{{ $t(["Back"]) }}
					</v-btn>
				</v-col>
			</v-row>
		</v-footer>
	</div>
</template>

<script>
import ProductItem from "../../components/ProductItem.vue";

import { useOrderStore } from "../../store/order";

export default {
	name: "NewOrder",
	data: () => ({
		products: [
			{
				id: 1,
				name: "2025 Terry Fox Run T-Shirt",
				price: 30,
				image: "2025_ShortSleeve.jpg",
			},
			{
				id: 2,
				name: "2025 Terry Fox Run T-Shirt Youth",
				price: 25,
				image: "2025_YouthShirt.jpg",
			},
			{
				id: 3,
				name: "2025 Terry Fox Run Long Sleeve T-Shirt",
				price: 40,
				image: "2025_LongSleeve.jpg",
			},
			{
				id: 4,
				name: "2025 Terry Fox Run Men's Performance T-Shirt",
				price: 45,
				image: "2025_PerformanceMen.jpg",
			},
			{
				id: 5,
				name: "2025 Terry Fox Run Women's Performance T-Shirt",
				price: 45,
				image: "2025_PerformanceWomen.jpg",
			},
			{
				id: 6,
				name: "Vintage T-Shirt",
				price: 10,
				image: "",
			},
			{
				id: 7,
				name: "Terry Fox Run Volunteer T-Shirt",
				price: 7,
				image: "2025_VolunteerShirt.jpg",
			},
		],
		priceTotal: 0,
		quantityTotal: 0,
		miscItem: false,
		miscItemPrice: 0,
		validMiscItemPrice: 0,
		allQuantityTotals: {},
		allPriceTotals: {},
		noItemErrorMsg: false,
		textfieldError: false,
		textfieldErrorMsg: "",
	}),
	setup() {
		const store = useOrderStore();

		return {
			store,
		};
	},
	components: {
		ProductItem,
	},
	mounted() {
		if (this.store.newOrderItems[this.products.length + 1] != undefined) {
			this.miscItem = true;
			this.miscItemPrice =
				this.store.newOrderItems[this.products.length + 1].total.toFixed(2);
		}
	},
	watch: {
		"$i18n.locale"() {
			if (this.textfieldError) {
				this.textfieldError = false;
				this.textfieldErrorMsg = "";
			}
		},
		miscItem(state) {
			if (state == true) {
				this.updateTotalBtn(this.products.length + 1, 1, 0);

				this.miscItemPrice = (0).toFixed(2);
			} else {
				this.updateTotalBtn(this.products.length + 1, 0, 0);

				this.miscItemPrice = (0).toFixed(2);
				this.store.setNewOrderItems(this.products.length + 1, {
					name: "Miscellaneous Item",
					price: 0,
					quantity: 0,
					total: 0,
				});
			}
		},
		miscItemPrice(price) {
			let currencyRegex =
				/^\$?([1-9]{1}[0-9]{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))$|^\-?\$?([1-9]{1}\d{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))$|^\(\$?([1-9]{1}\d{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))\)$/;

			if (price != "" && currencyRegex.exec(price)) {
				this.validMiscItemPrice = parseFloat(price);

				this.updateTotalBtn(this.products.length + 1, 1, parseFloat(price));

				this.store.setNewOrderItems(this.products.length + 1, {
					name: "Miscellaneous Item",
					price: parseFloat(price),
					quantity: 1,
					total: parseFloat(price),
				});
			}
		},
		quantityTotal(quantity) {
			if (quantity > 0) {
				this.noItemErrorMsg = false;
			}
		},
	},
	methods: {
		maskCurrency() {
			this.miscItemPrice = parseFloat(this.validMiscItemPrice).toFixed(2);
		},
		updateTotalBtn(id, quantity, price) {
			this.allQuantityTotals[id] = quantity;
			this.allPriceTotals[id] = price;

			this.quantityTotal = Object.values(this.allQuantityTotals).reduce(
				(partialSum, a) => partialSum + a,
				0
			);
			this.priceTotal = Object.values(this.allPriceTotals).reduce(
				(partialSum, a) => partialSum + a,
				0
			);

			this.store.setTotalPriceAllItems(this.priceTotal);
		},
		checkValidMiscItemPrice() {
			if (
				this.miscItem &&
				(this.miscItemPrice == "" || this.miscItemPrice == "0.00")
			) {
				this.textfieldErrorMsg = this.$gettext(
					this.$t(["Amount must be greater than 0"])
				);
			} else if (this.miscItem && parseInt(this.miscItemPrice) < 3) {
				this.textfieldErrorMsg = this.$gettext(
					this.$t(["Minimum amount is $3.00"])
				);
			} else {
				this.textfieldError = false;
				this.textfieldErrorMsg = "";

				return true;
			}

			this.textfieldError = true;

			// Scroll to error
			this.$nextTick(() => {
				const el = this.$refs.miscInput.$el.querySelector("input");
				this.$vuetify.goTo(el);

				return;
			});

			return false;
		},
		selectAllText() {
			let element = this.$refs.miscInput.$el.querySelector("input");

			this.$nextTick(() => {
				element.select();
			});
		},
		goToSummary() {
			if (this.checkValidMiscItemPrice()) {
				if (this.quantityTotal > 0) {
					this.$router.push("/newOrderSummary");
				} else {
					this.noItemErrorMsg = true;
				}
			}
		},
		backToHome() {
			this.store.clearOrderStore();
			this.$router.push("/home");
		},
		incrementQuantity() {
			this.quantity++;
		},
		decrementQuantity() {
			if (this.quantity !== 0) {
				this.quantity--;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
// Center error message
div ::v-deep .v-messages {
	text-align: center;
}
</style>
